<script>
import  { Sketch }  from '@ckpack/vue-color'
import ColorPicker from '@/views/Admin/Public/ColorPicker.vue'
import Select from '@/components/Form/Select.vue'
export default {
    components:{ Sketch, ColorPicker, Select },
    props: ['colors', 'location', 'text', 'top', 'left','defaultColor'],
    data(){
      return {
        availableItems: [
          {id: 'Barlow Condensed', name: 'Barlow Condensed'},
          {id: 'Birthstone', name: 'Birthstone'},
          {id: 'Charm', name: 'Charm'},
          {id: 'Fredoka, sans-serif', name: 'Fredoka' },
          {id: 'Libre Baskerville', name: 'Libre Baskerville'},
          {id: 'Playfair Display', name: 'Playfair Display'},
          {id: 'Poppins', name: 'Poppins'},
          {id: 'Raleway', name: 'Raleway'},
          {id: 'Story Script, sans-serif', name: 'Story Script' },
          {id: 'Titan One', name: 'Titan One'},
          {id: 'Merriweather', name: 'Merriweather'},
          {id: 'Manrope', name: 'Manrope'},
          {id: 'Cormorant Garamond', name: 'Cormorant Garamond'},
        ],
        color: null
      }
    },  
    mounted() {
        this.color = this.colors.find(x => x.location == this.location);

        if(this.color == null) {
          this.color = { location: this.location, id: 0, color: this.defaultColor, font_family: '', outline: 'black', is_lower_case: false };
           this.colors.push(this.color);
        }
    },
    methods: {
      changeuppercase: function() {
        this.color.is_lower_case = !this.color.is_lower_case;
      }
    },
    watch:
    {
      colors(newvalue){
         this.color = this.colors.find(x => x.location == this.location);
      }
    }
}

</script>
<template>
  <section class="opacity-admin-bg" :style="{ 'top': top, 'left': left }" v-if="color != null">
    <div class="StyleSelector-font"><Select :selectItems="availableItems" :prop="'StyleSelector-' + location" v-model:selectedItemSysID="color.font_family" :currentItemDisplayName="color.font_family"></Select></div>
    <div>
      <button class="btn btn-default" @click="changeuppercase()" v-tooltip="'Små/Stora bokstäver'">
      <span v-if="color.is_lower_case">abc</span>
      <span v-else>ABC</span>
      </button>
    </div>
    <div>
      <ColorPicker :color="color" :text="text"></ColorPicker>
    </div>
    <div>
      <ColorPicker :color="color" :text="'Kontur'" :isOutline="true"></ColorPicker>
    </div>
  </section>
</template>

<style scoped>

  .opacity-admin-bg {
    border-radius: 3px;
    padding: 3px;
    background-color: rgb(115 94 80 / 85%);
  }

  section {
    position:absolute;
    z-index: 10;
    display: flex;
    align-items: center;
  }

  button {
    border-radius: 2px;
    padding: 6px 10px;
    margin: 0px;
    border: 0px;
  }

  .StyleSelector-font {
    width: 200px;
    margin-right: -7px;
  }
 
</style>